import tippy, { animateFill } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/dist/backdrop.css'
import 'tippy.js/animations/shift-away.css'


const tooltip = {
  init: () => {
    tippy('[data-tippy-content]', {
      animateFill: true,
      plugins: [animateFill],
      placement: 'bottom',
    })
  },
}

export { tooltip }
